import { atom, selector } from 'recoil';
import { OfferListing, Option } from '~/common/models';

export const ActiveSpecialOffers = atom<OfferListing[]>({
  key: 'ActiveSpecialOffers',
  default: [],
});

export const SpecialOffersByCategory = selector<OfferListing[]>({
  key: 'SpecialOffersByCategory',
  get: ({ get }) => {
    const allOffers = get(ActiveSpecialOffers);
    const selectedOffer = get(SelectedOfferCategory);
    if (selectedOffer.value === 'All Categories') {
      return allOffers;
    }

    return allOffers.filter((o) => o.category === selectedOffer.value);
  },
});

export const SelectedOfferCategory = atom<Option>({
  key: 'SelectedOfferCategory',
  default: {
    label: 'All Categories',
    value: 'All Categories',
  },
});
